import React from "react";
import moment from "moment";
import { useTranslation } from "react-i18next";
import "./invoice.css";

const BillCollectInvoiceWithNote = React.forwardRef((props, ref) => {
  const { t } = useTranslation();
  const { billingData, ispOwnerData, customerData, paymentDate } = props;

  const Invoice = ({ title }) => (
    <div className="rcn-invoice">
      {/* COPY TITLE */}
      <h5 className="text-center ">{title}</h5>

      {/* HEADER */}
      <div className="invoice-top">
        <div>
          <div className="invoice-logo">
            <strong>{ispOwnerData?.company}</strong>
          </div>
          <div>{ispOwnerData?.address}</div>
        </div>
      </div>

      {/* INFO SECTION */}
      <div className="invoice-info-row">
        {/* BILL TO */}
        <div className="info-box">
          <div className="info-title">{t("billTo")}</div>

          <div>
            <b>{t("name")}:</b> {customerData?.name}
          </div>

          {customerData?.mobile && (
            <div>
              <b>{t("mobile")}:</b> {customerData?.mobile}
            </div>
          )}

          {customerData?.address && (
            <div>
              <b>{t("address")}:</b> {customerData?.address}
            </div>
          )}

          {/* PACKAGE */}
          <div>
            <b>{t("package")}:</b>{" "}
            {customerData?.userType === "simple-queue" ||
            customerData?.userType === "firewall-queue"
              ? customerData?.queue?.package
              : customerData?.pppoe?.profile}
          </div>
        </div>

        {/* BILL INFO */}
        <div className="info-box">
          <div className="info-title">{t("billInfo")}</div>

          <div>
            <b>{t("paidDate")}:</b> {moment(paymentDate).format("DD MMM YYYY")}
          </div>

          <div>
            <b>{t("billingCycle")}:</b>{" "}
            {moment(billingData?.billingCycle).format("DD MMM YYYY")}
          </div>

          {billingData?.collectedBy && (
            <div>
              <b>{t("billCollected")}:</b> {billingData?.collectedBy}
            </div>
          )}

          <div>
            <b>{t("medium")}:</b> {billingData?.medium}
          </div>
        </div>
      </div>

      {/* ITEM TABLE */}
      <table className="invoice-table">
        <thead>
          <tr>
            <th>{t("billDhoron")}</th>
            <th>{t("billComment")}</th>
            <th>{t("amount")}</th>
            <th>{t("due")}</th>
            <th>{t("discount")}</th>
          </tr>
        </thead>

        <tbody>
          <tr>
            <td>
              {billingData?.billType === "bill"
                ? t("bill")
                : t("connectionFee")}
            </td>

            <td>
              {billingData?.startDate &&
                moment(billingData?.startDate).format("DD MMM YYYY")}
              {" - "}
              {billingData?.endDate &&
                moment(billingData?.endDate).format("DD MMM YYYY")}{" "}
              {billingData?.month} {billingData?.note}
            </td>

            <td>{billingData?.amount}</td>

            <td>{billingData?.due}</td>

            <td>{billingData?.discount}</td>
          </tr>
        </tbody>
      </table>

      {/* NOTES */}
      <div className="invoice-notes">
        <strong>{t("note")}:</strong>
        <div className="note-box">{t("please keep this invoice safely")}.</div>

        {/* <div className="balance-due">
          {t("balanceDue")}: <strong>{billingData?.amount}</strong>
        </div> */}
      </div>

      <div className="d-flex justify-content-between mt-5">
        {/* Proprietor */}
        <div className="text-center">
          <div
            style={{
              borderTop: "2px solid #000",
              width: "180px",
              margin: "0 auto 5px",
            }}
          ></div>
          <p className="mb-0">{t("proprietor")}</p>
        </div>

        {/* Customer */}
        <div className="text-center">
          <div
            style={{
              borderTop: "2px solid #000",
              width: "180px",
              margin: "0 auto 5px",
            }}
          ></div>
          <p className="mb-0">{t("customer")}</p>
        </div>
      </div>
    </div>
  );

  return (
    <div ref={ref}>
      {billingData?.status === "both" && (
        <>
          <Invoice title={t("officeCopy")} />
          <hr className="invoice-divider" />
        </>
      )}

      <Invoice title={t("customerCopy")} />
    </div>
  );
});

export default BillCollectInvoiceWithNote;
